module.exports = __webpack_public_path__ + "static/media/26UNRWA14.784a9b2c.jpg";